export default {
    name: "ReceiptManage",
    data() {
        return {
            searchForm: {
                // 提单编号
                billNo: '',
                // 快递单号
                orderNo: '',
                // 快递公司
                expressCompany: '',
                // 发件人联系电话
                sendPhone: '',
                // 收件人联系电话
                collectPhone: '',
                // 签收状态
                status: '',
                pageIndex: 1,
                pageSize: 50
            },
            tableData: [],
            selected: [],
            total: 0
        }
    },
    created(){
        let conditionParam = this.$routerUtil.getParam();
        if(conditionParam && conditionParam.searchForm){
            conditionParam = conditionParam.searchForm;
        }
        console.log(conditionParam);
        this.$routerUtil.clearParam();
        if(conditionParam){
            this.$nextTick(() => {
                this.searchForm = conditionParam;
                this.doSearch();
            });
        }
    },
    methods: {
        handleSizeChange(val){
            this.searchForm.pageSize = val;
            this.doSearch();
        },
        handleCurrentChange(val){
            this.searchForm.pageIndex = val;
            this.doSearch();
        },
        handleSelectionChange(val) {
            this.selected = val;
        },
        rowClick(row){
            this.$refs.table.toggleRowSelection(row);
        },
        doSearch() {
            const param = this.$paramUtil.clearEmpty(this.searchForm);
            this.$axios.get('/api/billOfLadings/billOfLadingSign', {params: param}).then(response => {
                this.tableData = response.data.resultData.rows;
                this.total = response.data.resultData.total;
            }).catch(e => {
                console.log(e);
                this.$message({
                    message: this.$t('common.message.operateFail'),
                    type: 'error',
                    center: true
                });
            });
        },
        doReceipt(){
            const row = this.getSelectedRow();
			if (row) {
				const conditionData = new Object();
				conditionData.searchForm = this.searchForm;
                conditionData.row = row;
                if (conditionData.row.status === 1) {
                    this.$message({
                        message: this.$t('receiptManage.message.isAlreadyReceipt'),
                        type: 'warning',
                        center: true
                    });
                    return null
                } else {
                    this.$router.push('BillSignReceived');
                    this.$routerUtil.setParam(conditionData);
                }
			}
        },
        getSelectedRow(){
            if (this.selected.length > 1) {
                this.$message({
                    message: this.$t('common.message.onlyOneRow'),
                    type: 'warning',
                    center: true
                });
                return null
            }
            if (this.selected.length < 1) {
                this.$message({
                    message: this.$t('common.message.atLastOneRow'),
                    type: 'warning',
                    center: true
                });
                return null
            }
            return this.selected[0];
        },
        doReset(){
            this.$refs.searchForm.resetFields();
        }
    }
}
